module.exports = __webpack_public_path__ + "assets/assets/images/results/results-illustration.15251fca.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/results/results-illustration.png
// module id = 501
// module chunks = 0